export default function disableContrast() {
    document.getElementById('cya11y-filter-style')?.remove();
    document.body.classList.remove('cya11y-filter', 'cya11y-dark-contrast');
}